import { render, staticRenderFns } from "./MetaTagsPerLanguageInput.vue?vue&type=template&id=34fc5208&scoped=true"
import script from "./MetaTagsPerLanguageInput.vue?vue&type=script&lang=js"
export * from "./MetaTagsPerLanguageInput.vue?vue&type=script&lang=js"
import style0 from "./MetaTagsPerLanguageInput.vue?vue&type=style&index=0&id=34fc5208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fc5208",
  null
  
)

export default component.exports